import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  getCategories,
  getOfferFavorites,
  getOffers,
  getStates,
} from "../../api";
import ContactModal from "../../components/contact_modal";
import FillterModal from "../../components/fillter_modal";
import ItemCard from "../../components/item";
import LgSearch from "../../components/Lg_search";
import ShowModal from "../../components/show_modal";
import SmallSearch from "../../components/small_search";
import { cities_data, markets_data } from "../../data";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useAuth } from "../../store/authProvider";
import Client from "../../utils/client";
import LoadingCircle from "../auction/component/loading";
import notFound from "../../images/not-found.png";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import Skelton from "../../icons/skelton";
import PlaceOrderModal from "../../components/place_order_modal";
import { useTranslation } from "react-i18next";

const Sell = () => {
  const { isAuth } = useAuth();

  const [showFilters, setShowFilters] = useState(false);

  const navigator = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [offer, setOffer] = useState();
  const [crop, setCrop] = useState([]);
  const [state, setState] = useState([]);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  const [priceSort, setPriceSort] = useState(null);

  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Crops Orders",
  });

  const { data: categories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const {
    data: offers,
    isFetching,
    refetch,
  } = useQuery({
    // include priceSort in the key
    queryKey: ["offers_buy", priceSort],
    queryFn: () =>
      getOffers(
        "buy",
        state.map((e) => e.value),
        crop.map((e) => e.value),
        getValues().search_word,
        page, // page
        priceSort // ← pass it here
      ),
    onSuccess: (res) => setData([...new Set([...data, ...res.data])]),
    // onSuccess: (res) => setData([...new Set([...res.data])]),
    refetchOnWindowFocus: false,
    initialData: [],
  });
  const getOffer = async (id) => {
    const response = await Client.get(`/offer/${id}`).then((res) => res.data);
    setOffer(response);
    setShowModal(true);
    const user_id = localStorage.getItem("user_id");
    await Client.post("/admin/logs", {
      user_id: isAuth ? user_id : null,
      action: "Product View",
      product_type: "Crops Product",
      product_id: id.toString(),
    });
  };

  const { data: offersFavorites } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => getOfferFavorites(),
    initialData: [],
    enabled: isAuth,
  });

  const onSubmit = (search) => {
    refetch();
  };
  const handlePage = () => {
    setPage(page + 1);
  };

  useEffect(() => {
    refetch();
  }, [page]);

  return (
    <>
      <Helmet>
        ‍<title>طلبات المحاصبل - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="طلبات المحاصيل - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      {showFilters && (
        <FillterModal
          categories={categories}
          crop={crop}
          setCrop={setCrop}
          setShowFilters={setShowFilters}
          states={states}
          setState={setState}
          state={state}
          // name="المحصول"
          name={t("common.crop")}
        />
      )}
      {showModal && (
        <ShowModal
          offer={offer}
          cities_data={cities_data}
          markets_data={markets_data}
          setShowContactModal={setShowContactModal}
          setShowOrderModal={setShowOrderModal}
          setShowModal={setShowModal}
          states={states}
          favoriteOffers={offersFavorites}
          type="مطلوب"
        />
      )}
      {showContactModal && (
        <ContactModal offer={offer} setShowContactModal={setShowContactModal} />
      )}
      {showOrderModal && (
        <PlaceOrderModal
          item={offer}
          setShowOrderModal={setShowOrderModal}
          tradeType={"Offer"}
          negotiationType={"Crop"}
        />
      )}

      <div className="grid w-11/12 grid-cols-2 gap-5 mt-10 lg:w-[81rem] lg:gap-2 lg:grid-flow-row lg:grid-cols-5 mx-6 lg:mx-0 lg:px-20 ">
        {/* sm search */}
        <SmallSearch
          page={1}
          onSubmit={handleSubmit(onSubmit)}
          register={register}
          categories={categories}
          states={states}
          crop={crop}
          state={state}
          setState={setState}
          setCrop={setCrop}
          setShowFilters={setShowFilters}
          // text="إضافة طلب"
          text={t("common.add_request")}
          priceSort={priceSort}
          setPriceSort={setPriceSort}
          setPage={setPage}
        />

        {/* lg search */}
        <LgSearch
          page={1}
          onSubmit={handleSubmit(onSubmit)}
          register={register}
          setShowFilters={setShowFilters}
          // text="إضافة طلب"
          text={t("common.add_request")}
          priceSort={priceSort}
          setPriceSort={setPriceSort}
          setPage={setPage}
          search_placeholder={t("common.request_search_placeholder")}
        />

        {data.length === 0 ? (
          <div className="flex flex-col col-span-2 mt-20 justify-center text-center lg:col-span-5">
            <div className="font-bold mx-auto">
              <img src={notFound} />
            </div>
            <div className="h-6"></div>
            <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold ">
              {/* عذراً لا توجد محاصيل{" "} */}
              {t("common.no_crops")}
            </div>
          </div>
        ) : (
          data.map((item) => (
            <ItemCard
              item={item}
              getOffer={(id) => getOffer(id)}
              editLink={`/editformOrder/${item.id}`}
              key={item.id}
              type="buy"
              favoriteOffers={offersFavorites}
            />
          ))
        )}
        {isFetching && (
          <>
            {[...Array(7).keys()].map((e, i) => (
              <Skelton key={i} />
            ))}
          </>
        )}
      </div>
      {/* {!isFetching && offers.pageCount > offers.page && (
        <button
          onClick={handlePage}
          disabled={offers.pageCount < offers.page || isFetching}
          className="bg-primary mx-auto mt-8 text-white rounded-full py-1 px-4 hover:bg-[#42cf6a] hover:scale-105 transition disabled:opacity-50 disabled:animate-pulse"
        >
          عرض المزيد
        </button>
      )} */}
    </>
  );
};

export default Sell;

const ModalTable = ({ description, value, icon }) => {
  return (
    <div className="flex items-center gap-2 ">
      {/* {icon} */}
      <div className="my-4 text-sm leading-relaxed font-bold">
        {description}
      </div>
      <div className="w-5"></div>
      <div className="my-4 text-sm  leading-relaxed font-bold">{value}</div>
    </div>
  );
};
export const dropdownStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? "#613917" : "#915122",
    borderRadius: "67px",
    height: "49px",
    paddingLeft: "8px",
    paddingRight: "8px",
    fontWeight: "300",
    boxShadow: state.isFocused ? "none" : "none",
    "&:hover": {
      boxShadow: "none",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: " #613917",
  }),
};
